export const APP_PAGES = {
  APP: 'App',
  ABSCENCE_MANAGEMENT: 'AbsenceSettingsPage',
  ABSENCE_CALENDAR: 'AbsenceCalendarPage',
  ABSENCE_REQUESTS: 'AbsenceRequestsPage',
  ABSENCE_REPORT_PAGE: 'AbsenceReportPage',
  RESET_PASSWORD: 'ResetPasswordPage',
  FORGOTTEN_PASSWORD: 'ForgottenPasswordPage',
  RESET_LINK: 'ResetLinkSentPage',
  LOGIN_PAGE: 'LoginPage',
  LOGIN_AUTHENTICATION_PAGE: 'LoginAuthenticationPage',
  ANNOUNCEMENTS: 'AnnouncementsPage',
  ANNOUNCEMENT_CATEGORY: 'AnnouncementCategoryPage',
  ACTION_PLANS: 'ActionPlansPage',
  ACTION_PLAN_DETAILS: 'ActionPlanDetailsPage',
  ATTRIBUTES: 'AttributesPage',
  CANDIDATES: 'CandidatesPage',
  CANDIDATE_DETAILS: 'CandidateDetailsPage',
  COMPANY_OVERVIEW: 'CompanyOverviewPage',
  COMPETENCE_MAP: 'CompetenceMapPage',
  COMPARE: 'CompareReportPage',
  COURSES: 'CoursesPage',
  COURSE_DETAILS: 'CourseDetailsPage',
  CYCLES_PAGE: 'CyclesPage',
  CYCLE_DETAILS_PAGE: 'CycleDetailsPage',
  DASHBOARD: 'DashboardPage',
  DIVISIONS: 'DivisionsPage',
  DISABLE_AUTHENTICATION_PAGE: 'DisableAuthenticationPage',
  SIGN_UP: 'SignUpPage',
  ATTRIBUTE_REPORT: 'AttributeReportPage',
  JOBS: 'JobsPage',
  JOB_DETAILS: 'JobDetailsPage',
  JOB_POSTING_DETAILS: 'JobPostingDetailsPage',
  TIME_TO_HIRE_REPORT: 'TimeToHireReportPage',
  JOB_TITLES: 'JobTitlesPage',
  LEVELING: 'LevelingPage',
  FILL_SURVEY: 'FillSurveyPage',
  HEADCOUNT_REPORT_PAGE: 'HeadcountReportPage',
  NOT_FOUND: 'PageNotFound',
  ONE_ON_ONE: 'OneOnOnePage',
  ONE_ON_ONE_DETAILS: 'OneOnOneDetailsPage',
  ONE_ON_ONE_REPORT: 'OneOnOneReportPage',
  ORGANIZATION: 'OrganizationPage',
  ORGANIZATION_SETTINGS_DOCUMENTS: 'OrganizationSettingsDocumentsPage',
  ORGANIZATION_SETTINGS_FEATURES: 'OrganizationSettingsFeaturesPage',
  ORGANIZATION_SETTINGS_PERMISSIONS: 'OrganizationSettingsPermissionsPage',
  SLACK_INTEGRATION: 'SlackIntegrationPage',
  PEOPLE_INFO_SETTINGS: 'PeopleInfoSettingsPage',
  PEOPLE: 'PeoplePage',
  PEOPLE_ABSCENCES: 'PeopleAbsencesPage',
  PEOPLE_ACTION_PLANS: 'PeopleActionPlansPage',
  PEOPLE_CAREER: 'PeopleCareerPage',
  PEOPLE_COURSES: 'PeopleCoursesPage',
  PEOPLE_REVIEW_CYCLES: 'PeopleReviewCyclesPage',
  PEOPLE_INFO: 'PeopleInfoPage',
  PEOPLE_DOCUMENTS: 'PeopleDocumentsPage',
  PEOPLE_ONE_ON_ONE: 'PeopleOneOnOnePage',
  PEOPLE_PRIVATE_NOTES: 'PeopleNotesPage',
  PEOPLE_INSIGHTS: 'PeopleInsightsPage',
  PEOPLE_ROLES: 'PeopleRolesPage',
  PRIVATE_NOTES: 'PrivateNotesPage',
  PRICING: 'PricingPlansPage',
  PUBLIC_JOB: 'PublicJobPage',
  PUBLIC_JOB_UNAVAILABLE: 'PublicJobUnavailablePage',
  APPLY_JOB: 'ApplyJobPage',
  RELEASE_NOTES: 'ReleaseNotesPage',
  SKILLS_MATRIX: 'SkillsMatrixPage',
  SURVEYS: 'SurveysPage',
  SURVEYS_HISTORY: 'SurveysHistoryPage',
  SURVEY_HISTORY: 'SurveyHistoryPage',
  SURVEY_REPORT: 'SurveyReportPage',
  SURVEY_SETTINGS: 'SurveySettingsPage',
  SURVEY_SUMMARY: 'SurveySummaryPage',
  SURVEY_SUMMARY_DETAILS: 'SurveySummaryDetailsPage',
  TAGS: 'TagsPage',
  TAG_CATEGORY: 'TagCategoryPage',
  THANK_YOU: 'ThankYouPage',
  TWO_FACTOR_OPTIONS_PAGE: 'TwoFactorOptionsPage',
  UNAUTHORIZED_ACCESS: 'UnauthorizedAccessPage',
  UPGRADE_REQUIRED: 'UpgradeRequired',
  STARTER_PLAN: 'StarterPlan',
  INSTRUCTION_GUIDE: 'InstructionGuide',
  SUCCESSION_KEY_JOBS: 'SuccessionKeyJobsPage',
  SUCCESSION_KEY_JOB: 'SuccessionKeyJobPage',
  SUCCESSION_POOLS: 'SuccessionPoolsPage',
  SUCCESSION_POOL: 'SuccessionPoolPage',
  SUCCESSION_SETTINGS: 'SuccessionSettingsPage',
};

export const APP_COMPONENTS = {
  ATTRIBUTE_CHIP: 'attributeChip',
  SELECT_FIELD: 'selectField',
};

export const PARAMS = {
  ABSENCE: 'absence',
  ABSENCE_SET: 'absence_set',
  ABSENCE_TYPE: 'absence_type',
  ATTRIBUTE: 'attribute',
  AVAILABLE_MANAGERS: 'available_managers', // multiple (user ids) user endpoints
  ABSENCE_REQUEST_DATES: 'ar_dates',
  WITHOUT_ACTION_PLANS: 'has_plans',
  CANDIDATE: 'candidate',
  CALENDAR_FROM: 'calendar_from',
  CALENDAR_TO: 'calendar_to',
  COURSE_ATTRIBUTE: 'course__attribute',
  COURSE_LEVEL: 'course__level',
  COURSE_TAGS: 'course__tags',
  CREATOR: 'creator',
  CREATED_FOR: 'created_for',
  COMPLETION_STATUS: 'completion_status',
  CYCLE_STEP_TYPE: 'step_type',
  DATE_FROM: 'date_from',
  DATE_TO: 'date_to',
  DESCRIPTION: 'description',
  DIVISION: 'division',
  DEPARTMENT: 'department',
  EXCLUDE: 'exclude', // multiple (user ids) user endpoints
  EXCLUDE_ROLE: 'exclude_role', // single ('ADMIN', 'MODERATOR', 'USER', 'ASSOCIATE') user endpoints
  EXCLUDE_STATUS: 'exclude_status', // single ('IDLE', 'INVITED', 'WITH_ACCESS', 'SUSPENDED') user endpoints
  EXCLUDE_USER_STATUS: 'exclude_user_status', // single ('IDLE', 'INVITED', 'WITH_ACCESS', 'SUSPENDED') user endpoints
  EXCLUDE_ARCHIVED_QUESTIONS: 'exclude_archived_questions',
  EXCLUDE_ATTRIBUTE_TYPE: 'exclude_type',
  JOB_TITLE: 'position', // multiple (user ids) user endpoints
  LEVEL: 'level',
  AT_ABSENCE_YEAR: 'at_absence_year', // add year
  PAGE: 'page',
  PAGE_SIZE: 'page_size',
  REPORT: 'report',
  REPORT_TO: 'report_to', // multiple (user ids) user endpoints
  REVIEWERS: 'reviewers',
  RBAC_SCOPE_PERMISSION: 'scope_permission', // used to get users by scope permission
  SCOPE: 'scope', // multiple ('ME', 'DIR_REPORTS,'ALL_REPORTS', 'ASSOCIATES', 'SHARED_COLLAB', 'SHARED_VIEW') user endpoints
  STATUS: 'status', // multiple ('IDLE', 'INVITED', 'WITH_ACCESS', 'SUSPENDED') user endpoints
  SURVEY_TYPE: 'survey_type',
  SURVEY_ID: 'survey_id',
  SURVEY_SUMMARY_TYPE: 'survey__type',
  SELECTION_STEP: 'selection_step',
  TAGS: 'tags', // multiple (ids) user endpoints
  TRACK: 'level__track', // multiple (ids) user endpoints
  TYPE: 'type',
  IS_ACTIVE: 'is_active',
  IS_PRIVATE_ATTRIBUTE: 'is_private',
  ROLE: 'role', // multiple ('ADMIN', 'MODERATOR', 'USER', 'ASSOCIATE') user endpoints
  ORDERING: 'ordering',
  START_AT: 'from_date',
  END_AT: 'to_date',
  FROM: 'from',
  TO: 'to',
  START: 'start',
  SEARCH: 'search',
  END: 'end',
  USED_AFTER: 'used_after',
  USED_BEFORE: 'used_before',
  START_AFTER: 'created_at_after',
  END_AFTER: 'created_at_before',
  SENT_AT_AFTER: 'sent_at_after',
  SENT_AT_BEFORE: 'sent_at_before',
  MEETING_TIME_START: 'meeting_time_after',
  MEETING_TIME_END: 'meeting_time_before',
  MODERATOR: 'moderator',
  SUBJECT: 'subject',
  IMPRESSION: 'meeting_impression',
  USER: 'user',
  IS_FINISHED: 'is_finished',
  ID: 'id',
  DUE_DATE: 'due_date',
  YEAR: 'year',
  JOB: 'job',
  STAGE: 'stage',
  TAG: 'tag',
  JOB_TYPE: 'job_type',
  FAMILY: 'job_family',
  CRITICALITY: 'criticality',
  OWNER: 'owner',
  SHOW_REMOVED: 'show_removed',
};

const DEFAULT_PAGE_TABLE_PARAMS = [
  PARAMS.PAGE,
  PARAMS.PAGE_SIZE,
  PARAMS.SEARCH,
];

export const PAGE_WHITELISTED_PARAMS = {
  ABSENCE_CALENDAR: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.ID,
    PARAMS.CALENDAR_FROM,
    PARAMS.CALENDAR_TO,
  ],
  ACTION_PLANS: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.ORDERING,
    PARAMS.TAGS,
    PARAMS.USER,
    PARAMS.DUE_DATE,
    PARAMS.COMPLETION_STATUS,
  ],
  ATTRIBUTES: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.ORDERING,
    PARAMS.IS_ACTIVE,
    PARAMS.TYPE,
    PARAMS.TAGS,
  ],
  CYCLES: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.ORDERING,
    PARAMS.STATUS,
    PARAMS.CREATOR,
  ],
  CYCLE_DETAILS: [...DEFAULT_PAGE_TABLE_PARAMS],
  JOB_TITLES: [...DEFAULT_PAGE_TABLE_PARAMS, PARAMS.TAGS],
  LEARNING: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.LEVEL,
    PARAMS.ATTRIBUTE,
    PARAMS.TAGS,
  ],
  ABSENCE_REQUESTS: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.ORDERING,
    PARAMS.STATUS,
    PARAMS.TYPE,
    PARAMS.YEAR,
  ],
  TAGS: [PARAMS.SEARCH],
  ONE_ON_ONE: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.TAGS,
    PARAMS.IMPRESSION,
    PARAMS.MODERATOR,
    PARAMS.COMPLETION_STATUS,
    PARAMS.MEETING_TIME_START,
    PARAMS.MEETING_TIME_END,
  ],
  PEOPLE: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.ORDERING,
    PARAMS.ROLE,
    PARAMS.SCOPE,
    PARAMS.TAGS,
    PARAMS.STATUS,
    PARAMS.JOB_TITLE,
    PARAMS.TRACK,
    PARAMS.LEVEL,
    PARAMS.WITHOUT_ACTION_PLANS,
  ],
  PEOPLE_ACTION_PLANS: [
    PARAMS.PAGE,
    PARAMS.PAGE_SIZE,
    PARAMS.COMPLETION_STATUS,
    PARAMS.TAGS,
    PARAMS.DUE_DATE,
  ],
  PEOPLE_LEARNING: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.COURSE_LEVEL,
    PARAMS.COURSE_ATTRIBUTE,
    PARAMS.STATUS,
    PARAMS.COURSE_TAGS,
  ],
  PEOPLE_ONE_ON_ONE: [
    PARAMS.PAGE,
    PARAMS.PAGE_SIZE,
    PARAMS.COMPLETION_STATUS,
    PARAMS.TAGS,
  ],
  PRIVATE_NOTES: [
    PARAMS.PAGE,
    PARAMS.PAGE_SIZE,
    PARAMS.START_AT,
    PARAMS.END_AT,
  ],
  SURVEYS: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.ORDERING,
    PARAMS.TYPE,
    PARAMS.REVIEWERS,
    PARAMS.CREATOR,
    PARAMS.CREATED_FOR,
    PARAMS.STATUS,
  ],
  SURVEY_SECTIONS: [...DEFAULT_PAGE_TABLE_PARAMS],
  SURVEY_SUMMARY: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.CREATOR,
    PARAMS.ORDERING,
    PARAMS.SURVEY_SUMMARY_TYPE,
  ],
  SURVEYS_HISTORY: [
    PARAMS.PAGE,
    PARAMS.PAGE_SIZE,
    PARAMS.ORDERING,
    PARAMS.CREATED_FOR,
  ],
  JOBS: [...DEFAULT_PAGE_TABLE_PARAMS, PARAMS.DEPARTMENT, PARAMS.IS_ACTIVE],
  JOB_DETAILS: [PARAMS.SEARCH, PARAMS.STATUS, PARAMS.ORDERING],
  CANDIDATES: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.DEPARTMENT,
    PARAMS.JOB,
    PARAMS.STAGE,
    PARAMS.TAG,
  ],
  SUCCESSION_KEY_JOBS: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.JOB_TYPE,
    PARAMS.FAMILY,
    PARAMS.CRITICALITY,
  ],
  SUCCESSION_POOLS: [...DEFAULT_PAGE_TABLE_PARAMS, PARAMS.STATUS, PARAMS.OWNER],
  SUCCESSION_POOL_MEMBERS: [PARAMS.PAGE, PARAMS.PAGE_SIZE],
  SUCCESSION_SETTINGS: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.SEARCH,
    PARAMS.STATUS,
  ],
  SUCCESSION_KEY_JOB: [
    ...DEFAULT_PAGE_TABLE_PARAMS,
    PARAMS.SEARCH,
    PARAMS.STATUS,
  ],
};

export const ANNOUNCEMENTS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 20,
  [PARAMS.ORDERING]: '-published_at',
};

export const ABSENCE_CALENDAR_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 12,
};

export const ABSENCE_REQUESTS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-created_at',
};

export const ABSENCE_REPORT_USER_STATS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 20,
};

export const ACTION_PLANS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-modified_on',
};

export const PEOPLE_ACTION_PLANS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
};

export const COURSES_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 1000,
};

export const ATTRIBUTES_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-modified_on',
};

export const JOB_TITLES_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 1000,
  [PARAMS.ORDERING]: 'name',
  [PARAMS.IS_ACTIVE]: true,
};

export const SUCCESSION_KEY_JOBS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
};

export const SUCCESSION_POOLS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
};

export const SUCCESSION_POOL_MEMBERS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.SHOW_REMOVED]: false,
};

export const SUCCESSION_POOL_CHANGELOG_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
};

export const ONE_ON_ONE_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
};

export const PEOPLE_ONE_ON_ONE_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 30,
};

export const PRIVATE_NOTES_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
};

export const PEOPLE_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: 'first_name,id',
};

export const SURVEYS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-sent_at',
};

export const CYCLES_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-created_at',
};

export const CYCLE_DETAILS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 12,
};

export const SURVEYS_SUMMARY_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-created_at',
};

export const SURVEY_GROUPS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: 'title',
};

export const SURVEYS_HISTORY_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-sent_at',
};

export const PEOPLE_ABSENCE_REQUESTS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.ORDERING]: '-created_at',
};

export const PEOPLE_ABSENCE_UPCOMING_TIME_OFF_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 3,
};

export const JOBS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
  [PARAMS.IS_ACTIVE]: true,
};

export const JOB_DETAILS_DEFAULT_PARAMS = {
  [PARAMS.STATUS]: 'qualified',
};

export const CANDIDATES_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 20,
};

export const TIMELINE_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 20,
};
